module.exports = __webpack_public_path__ + "static/media/videoEditor-4.1a653a59.webp";